<template>
	<div class="results-toolbar results-toolbar--variant-three">
		<div class="results-toolbar__search">
			<Search
				placeholder="Search by form name, description, or ID"
				v-model.lazy="filters.search"
				@change="emitValues"
			/>
		</div>
		<Button
			v-if="notDefaultFilters"
			class="results-toolbar--customer-forms__reset-filters"
			className="btn--link"
			labelText="Restore Filters"
			:btnClick="resetFilters"
		/>
		<div class="results-toolbar--customer-forms__desktop" ref="desktopRef">
			<DropdownV2
				v-model="filters.enabled"
				:options="enabledOptions"
				:defaultValue="true"
				@change="emitValues"
			/>
			<DropdownV2
				v-model="filters.type"
				:options="typeOptions"
				defaultValue="all"
				@change="emitValues"
			/>
		</div>
		<div class="results-toolbar--customer-forms__mobile" ref="mobileRef">
			<Button
				className="btn--primary"
				iconClassName="icon-filter"
				:iconBeforeLabel="true"
				:btnClick="() => (displayFiltersModal = true)"
			/>
		</div>
		<div class="results-toolbar__counter" v-if="counter">
			<ResultCounter :counter="counter" />
		</div>
		<Modal
			v-if="displayFiltersModal"
			:display="true"
			title="Apply Filters"
			@show="displayFiltersModal = false"
		>
			<template #modal-content>
				<DropdownV2
					v-model="filtersModal.enabled"
					:options="enabledOptions"
					:defaultValue="true"
				/>
				<DropdownV2
					v-model="filtersModal.type"
					:options="typeOptions"
					defaultValue="all"
				/>
			</template>
			<template #modal-footer>
				<ButtonGroup>
					<template #container>
						<Button
							labelText="Apply Filters"
							className="btn--primary"
							:btnClick="applyFilterUsingModal"
							:disabled="!filtersModalHaveChanges"
						/>
						<Button
							labelText="Close"
							className="btn--link"
							:btnClick="closeModalFilters"
						/>
					</template>
				</ButtonGroup>
			</template>
		</Modal>
	</div>
</template>

<script>
import Search from '@/components/forms/search/search';
import ButtonGroup from '@/components/forms/button/button-group';
import Button from '@/components/forms/button/button';
import DropdownV2 from '@/components/forms/dropdown/dropdown-v2.vue';
import ResultCounter from '@/site-components/result-counter/result-counter';
import Modal from '@/components/shells/modal/modals';

// libraries
import { deepEqualNoFn } from '@/utils/object';
import _ from 'lodash';

export default {
	name: 'CustomerFormsManagerFilters',
	components: {
		Search,
		ButtonGroup,
		Button,
		DropdownV2,
		ResultCounter,
		Modal
	},
	props: {
		value: {
			type: Object,
			default: () => {}
		},
		defaultFilters: Object,
		counter: String
	},
	data() {
		return {
			displayFiltersModal: false,
			searchQuery: '',
			filters: {},
			filtersModal: {},
			enabledOptions: [
				{ text: 'All Statuses', value: 'all' },
				{ text: 'Enabled', value: true },
				{ text: 'Disabled', value: false }
			],
			typeOptions: [
				{ text: 'All Types', value: 'all' },
				{ text: 'Impact', value: 'I' },
				{ text: 'Laser', value: 'L' }
			]
		};
	},
	created() {
		this.updateLocalValues(this.value);
	},
	computed: {
		filtersModalHaveChanges() {
			return !deepEqualNoFn(this.filters, this.filtersModal, true);
		},
		notDefaultFilters() {
			// remove search from default
			const defaultFiltersLocal = _.cloneDeep(this.defaultFilters);
			delete defaultFiltersLocal.search;

			const filtersLocal = _.cloneDeep(this.filters);
			delete filtersLocal.search;

			return !deepEqualNoFn(defaultFiltersLocal, filtersLocal);
		}
	},
	methods: {
		updateLocalValues(obj) {
			this.filters = _.cloneDeep(obj);
			this.filtersModal = _.cloneDeep(obj);
		},
		applyFilterUsingModal() {
			this.filters = _.cloneDeep(this.filtersModal);
			this.displayFiltersModal = false;
			this.$emit('input', { ...this.filters });
		},
		resetFilters() {
			this.updateLocalValues(this.defaultFilters);

			this.$emit('input', { ...this.filters });
		},
		closeModalFilters() {
			this.filtersModal = _.cloneDeep(this.filters);
			this.displayFiltersModal = false;
		},
		emitValues() {
			this.filtersModal = _.cloneDeep(this.filters);
			this.$emit('input', { ...this.filters });
		}
	},
	watch: {
		value(newValue) {
			this.updateLocalValues(newValue);
		}
	}
};
</script>

<style lang="scss" scoped>
.results-toolbar--customer-forms {
	&__reset-filters {
		margin-left: auto;
	}

	&__mobile {
		@include mq($from: md-l) {
			display: none;
		}
	}

	&__desktop {
		display: none;
		z-index: 100;

		@include mq($from: md-l) {
			display: flex;
			gap: $gutter-lg;
		}
	}
}
</style>
